import * as types from "_constants";
import { axiosAPI } from "_utils/axios";

export function getSubscriptionAction() {
  return async (dispatch) => {
    try {
      const access_token = localStorage.getItem("access_token");
      if (access_token) {
        const r = await axiosAPI.get(`/patron/plans`, {
          headers: {
            Authorization: `Bearer ${access_token}`
          }
        });
        console.log('r.data', r.data);
        if (r.data.plans.length > 0) {
          dispatch({
            type: types.GET_PLANS_SUCCESS,
            payload: {
              plans: r.data.plans,
              artwork: r.data.artwork,
              isLoading: false,
            }
          });
        } else {
          // no plans for this user
          dispatch({
            type: types.GET_PLANS_SUCCESS,
            payload: {
              plans: [],
              artwork: {},
              isLoading: false,
            }
          });
        }
      } else {
        throw new Error(`Authorization not found`);
      }
    } catch (error) {
      dispatch({
        type: types.GET_PLANS_ERROR,
        payload: {
          error: error,
          isLoading: false,
        }
      });
    }
  };
}
